<template>
  <div>
    <div v-if="facility=='app'" class="app">
      <!-- <Mzszp/> -->
      <!--<Mnav/>
      <Mrecommend/>
      <Mactivity/>
      <Mvideo/>
      <MnewsList/> -->
    </div>
    <div v-else class="pc_exhibitor">
      <Zs/>
    </div>
  </div>
</template>

<script>
// import Mzszp from "./app/zszp";
import Zs from "./pc/index";
export default {
  components:{
    // Mzszp,
    Zs,
    // Mnav,
    // Mrecommend,
    // Mactivity,
    // Mvideo,
    // MnewsList,
    // Banner
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style scoped>
  .pc_exhibitor{
    background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/exhibitorBg.jpg");
    background-repeat: no-repeat;
    background-size: 100%;
    background-color: #f2f2f2;
  }
</style>